import { injectable } from 'inversify'
import { trim } from 'lodash-es'
import type { FeatureFlags, FeatureFlagsE2e } from '@/services/types'
import ConfigReader from '@/core/configReader'

@injectable()
export class FeatureFlagsService {
  public isFeatureEnabled(featureFlag: FeatureFlags): boolean {
    const config = ConfigReader.config()

    const featureFlagValueFromConfig = config.featureFlags[featureFlag]
    if (typeof featureFlagValueFromConfig === 'boolean') {
      return featureFlagValueFromConfig
    }

    const ffValue = localStorage.getItem(`tm::features::${featureFlag}`)
    return Boolean(ffValue) && !['disabled', 'false', '0'].includes(trim(ffValue?.toLowerCase()))
  }

  public isEnabledForE2e(featureFlag: FeatureFlagsE2e): boolean {
    const ffValue = localStorage.getItem(`tm::features-e2e::${featureFlag}`)
    return Boolean(ffValue) && !['disabled', 'false', '0'].includes(trim(ffValue?.toLowerCase()))
  }
}
